import { Button, Flex, InputGroup, Text, Textarea, useToast } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from 'react-query'
import { api } from '../../../../services/api'
import { user } from '../../../../helpers/user'
import { useEffect } from 'react'

const schema = z.object({
  observacao: z.string().nonempty(),
  codigo_liberador: z.string(),
  nome_liberador: z.string(),
  numero_pedido: z.string(),
  codigo_usuario: z.number(),
  nome_usuario: z.string(),
  nome_tela: z.string(),
  link_tela: z.string(),
})

async function liberarCotacao({ observacao, codigo_liberador, nome_liberador, numero_pedido, codigo_usuario, nome_usuario, nome_tela, link_tela }) {
  const response = await api.post('https://api.innovationbrindes.com.br/api/site/v2/fluxo-liberacao/inserir-liberacao-usuario', {
    motivo_liberacao: observacao,
    codigo_liberador,
    nome_liberador,
    numero_pedido,
    codigo_usuario,
    nome_usuario,
    nome_tela,
    link_tela,
  })
}

export function ObservacaoLiberacao({ codigo_liberador, nome_liberador, numero_pedido, refresh, onClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const toast = useToast({
    position: 'top',
    duration: 5000,
    isClosable: true,
  })

  const { isLoading, mutateAsync } = useMutation({
    mutationFn: liberarCotacao,
    onSuccess: async () => {
      await refresh()
      onClose()
      toast({
        title: 'Liberado com sucesso',
        status: 'success',
      })
    },
  })

  async function submitForm(data) {
    try {
      const params = {
        motivo_liberacao: data.observacao,
        codigo_usuario: user.codigo_usuario,
        nome_usuario: user.nome_usuario,
        ...data,
      }

      await mutateAsync(params)
    } catch (err) {
      console.log(err)
    }
  }

  const urlLocation = window.location.href

  useEffect(() => {
    setValue('codigo_liberador', codigo_liberador)
    setValue('nome_liberador', nome_liberador)
    setValue('numero_pedido', numero_pedido)
    setValue('codigo_usuario', user.codigo_usuario)
    setValue('nome_usuario', user.nome_usuario)
    setValue('nome_tela', 'SimulacaoFrete')
    setValue('link_tela', urlLocation)
  }, [codigo_liberador, nome_liberador, numero_pedido, user.codigo_usuario, user.nome_usuario])

  return (
    <Flex gap={2} flexDir="column" as="form" w="100%" onSubmit={handleSubmit(submitForm)}>
      <InputGroup maxW="600px">
        <Textarea
          type="text"
          placeholder="Motivo Liberação"
          w="100%"
          color="gray.700"
          borderColor="#95c620"
          {...register('observacao')}
          resize="none"
        />
      </InputGroup>
      {errors.observacao && <Text color="red.500">Campo obrigatório</Text>}

      <Button bgColor="#95c620" _hover={{ bgColor: '#95c620' }} loadingText="Verificando..." type="submit" alignSelf="flex-end" isLoading={isLoading}>
        Confirmar
      </Button>
    </Flex>
  )
}
